<template>
<div>
    <v-simple-table v-if="loaded">
        <template v-slot:default>
            <thead>
                <tr>
                    <th class="text-left">Name</th>
                    <th class="text-right">Change Team</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in items" :key="item.name">
                    <td>{{ item.name }}</td>
                    <td>
                        <div class="d-flex justify-end py-4">
                            <div class="mr-3" style="width:250px">
                                <v-select
                                    v-model="modelTeam[index]"
                                    :items="teams"
                                    item-text="name"
                                    item-value="id"
                                    @change="selectTeam"
                                    hide-details
                                    append-icon="fa-angle-down accent--text"
                                    flat dense
                                    label="Select">
                                </v-select>
                            </div>
                            <v-btn depressed class="accent" @click="tryToChange(item.uid)" :disabled="sending||modelTeam[index]==''">Change</v-btn>
                        </div>
                    </td>
                </tr>
            </tbody>
        </template>
    </v-simple-table>

    <SendingLoader v-else/>

    <DiagChangeFromTeam
        :model="showDiagChange"
        text="Are you sure to change the student from Team?"
        @cancel="cancel"
        @modify="changePlease" />
</div>  
</template>

<script>
import _ from 'lodash'
import Helpers from '@/services/helpers'
import Users from '@/firebase/users'
import Teams from '@/firebase/teams'
import DiagChangeFromTeam from '@/components/core/dialogs/DiagChangeFromTeam'

export default {
    data: () => ({
        loaded: false,
        sending: false,
        items: [],
        teams: [],
        modelTeam: [],
        selectedTeam: '',
        showDiagChange: false
    }),
    props: ['team'],
    components: {
        DiagChangeFromTeam
    },
    mounted() {
        this.init();
    },
    methods: {
        reinit() {
            this.loaded = false;
            this.items = [];
            this.teams = [];
            this.init();
        },
        init() {
            Users.getTeamMates(this.team.id)
                    .then(response => {
                        if (response.status == true) {
                            this.items = Helpers.formatItems(response.query, 'uid');
                            this.setModelTeam();
                            this.getTeams();
                        } else {
                            this.showError('An error ocurred. Please try later.')
                        }
                    });
        },
        setModelTeam() {
            this.modelTeam = [];
            this.items.forEach(dt => {
                    this.modelTeam.push('');
                });
        },
        getTeams() {
            Teams.getByCenter(this.team.center.id)
                    .then(response => {
                        if (response.status === true) {
                            this.teams = Helpers.formatItems(response.query);
                            this.loaded = true;
                        } else {
                            this.showError('An error ocurred. Please try later.')
                        }
                    });
        },
        selectTeam(e) {
            this.selectedTeam = e;
        },
        tryToChange(uid) {
            this.selectedStudent = uid;
            this.showDiagChange = true;
        },
        cancel() {
            this.setModelTeam();
            this.selectedTeam = '';
            this.showDiagChange = false;
        },
        changePlease() {
            this.sending = true;

            Users.setTeam(this.selectedStudent, this.selectedTeam)
                    .then(response => {
                        if (response === true) {
                            this.reinit();
                            this.$emit('reinit');
                            this.showDiagChange = false;
                            this.showError('Student changed from Team');
                        } else {
                            this.showError('An error ocurred. Please try later.');
                        }
                    });
        }
    }
}
</script>